import axios from 'axios';
import {setCookie} from "../../plugins/axios";

const url = 'https://www.elegantenterprisesinc.com/crm/api/';
const state = {
  tickets: [],
};

const getters = {
  tickets: state => state.tickets
};

const actions = {

};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}


